import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import AdvancedRecordTable from '../../components/Tables/advancedRecord/AdvancedRecordTable';

import { usePayableTable } from '../../modules/payable/table/hooks/usePayableTable';
import { PayableTableColumns } from '../../modules/payable/table/config/PayableTableColumns';
import { getPayableFilters } from '../../modules/payable/table/config/PayableTableFilters';
import { getPayableTableActions } from '../../modules/payable/types/PayableTableActions';

import { useSupplier } from '../../hooks/useSupplier';
import { usePayableDetail } from '../../modules/payable/detail/hooks/usePayableDetail';
import { useBasePurchase } from '../../hooks/purchases/useBasePurchase';

import PayableDetailModal from '../../modules/payable/detail/components/PayableDetailModal';
import PurchaseViewModal from '../../components/Modals/Purchases/PurchaseViewModal';

import { PayableFilter } from '../../modules/payable/types/PayableFilter.types';

const OverduePage = () => {
  const navigate = useNavigate();

  const { purchaseToViewLoaded, handleCloseViewModal } = useBasePurchase();

  const { list, paginator, size, fetchPayables, changeSize } =
    usePayableTable();

  const { isModalOpen, handleOpenDetailModal, handleCloseDetailModal } =
    usePayableDetail();

  const { handlerGetSuppliersForDropdown, suppliersDropdown } = useSupplier();

  /**
   * 🔥 SOLO vencidas
   */
  const baseFilter: PayableFilter = {
    statuses: ['OVERDUE'],
  };

  const [filters, setFilters] = useState<PayableFilter>(baseFilter);

  /**
   * 🔍 filtros
   */
  const handleFilterChange = (newFilters: PayableFilter) => {
    const merged = {
      ...baseFilter,
      ...newFilters,
    };

    setFilters(merged);

    fetchPayables(merged, 0);
  };

  /**
   * 🔄 reset
   */
  const handleResetFilters = () => {
    setFilters(baseFilter);

    fetchPayables(baseFilter, 0);
  };

  /**
   * 📄 paginación
   */
  const handlePageChange = (page: number) => {
    fetchPayables(filters, page);
  };

  const handlePageSizeChange = (newSize: number) => {
    changeSize(newSize, filters);
  };

  /**
   * 🚀 carga inicial
   */
  useEffect(() => {
    fetchPayables(baseFilter);

    handlerGetSuppliersForDropdown();
  }, []);

  const filterFields = getPayableFilters(suppliersDropdown);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <AdvancedRecordTable
        columns={PayableTableColumns}
        data={list}
        paginator={paginator}
        pageSize={size}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        url="/overdue-cxp"
        noDataMessage="No hay cuentas vencidas."
        getActions={(row) =>
          getPayableTableActions({
            row,
            handlers: {
              onView: (id) => handleOpenDetailModal(id),

              onPay: (id) => navigate(`/finance/cxp/register-payment/${id}`),

              onHistory: (id) => navigate(`/finance/cxp/payment-history/${id}`),
            },
          })
        }
      />

      <PayableDetailModal
        isOpen={isModalOpen}
        onClose={handleCloseDetailModal}
      />

      <PurchaseViewModal
        isOpen={purchaseToViewLoaded}
        onClose={handleCloseViewModal}
      />
    </DefaultLayout>
  );
};

export default OverduePage;
